module.exports = __webpack_public_path__ + "img/qrcode.d7f9f728.png";